import { pluralize as e, singularize as t } from "inflection";
//#region src/validation/validation.ts
var n = /^[0-9]*(\.)?([0-9]{1,2})?$/, r = /^[0-9]*(\.)?([0-9]{1,4})?$/, i = /^[0-9]*(\.)?([0-9]{1,10})?$/, a = /^[0-9]+$/, o = /^[-]?[0-9]+$/, s = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, c = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/, l = /^[0-9]{3}$/, u = /^[0-9]{5}$/, d = /^[0-9]{6}$/, f = /^[0-9]{8}$/, p = /^[0-9]{9}$/, m = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/, h = (e, t) => {
	if (typeof e != "string") return !1;
	switch (t) {
		case "2": return n.test(e);
		case "4": return r.test(e);
		case "10": return i.test(e);
	}
}, g = (...e) => (t, n) => e.reduce((e, r) => e || r(t, n), void 0), _ = (e) => Array.isArray(e) && e.length === 0 ? "This field is required" : (typeof e == "string" ? e.trim() : e) ? void 0 : "This field is required", ee = (e, t) => (n) => {
	if (!n || typeof n != "object") return t ?? "This field is required";
	let r = n[e];
	return (typeof r == "string" ? r.trim() : r) ? void 0 : t ?? "This field is required";
}, te = (e) => {
	if (Array.isArray(e) && e.length === 0) return "This field is required";
	let t = typeof e == "string" ? e.trim() : e;
	return t || t === 0 ? void 0 : "This field is required";
}, v = () => void 0, y = (e, t = "This field is required") => (n, r) => {
	let i = typeof n == "string" ? n.trim() : n;
	return r[e] ? i ? void 0 : t : void 0;
}, b = ({ otherField: e, values: t }, n = "This field is required") => (r, i) => {
	let a = i[e];
	if (t.includes(a)) return (typeof r == "string" ? r.trim() : r) ? void 0 : n;
}, x = (e) => {
	let t = /* @__PURE__ */ new Date();
	return e < new Date(Date.parse(`${t.getFullYear()}-${t.getMonth() + 1}-${t.getDate()} 00:00:00`)) ? "Date must be in the future" : void 0;
}, S = (e, t) => (n, r) => !r[e] || n > r[e] ? void 0 : t, C = (e) => e == null || e === "", w = (e, t) => (n, r) => {
	let i = r?.[e];
	if (!(C(n) || C(i))) return String(n) < String(i) ? t : void 0;
}, T = (e, t) => (n, r) => {
	let i = r?.[e];
	if (!(C(n) || C(i))) return Number(n) > Number(i) ? t : void 0;
}, E = (e, t) => (n, r) => {
	let i = r;
	return !i[e] || n < i[e] ? void 0 : t;
}, D = (e, t) => (n) => n > e ? void 0 : t ?? `Please enter a number greater than ${e}`, O = (e, t) => (n) => n >= e ? void 0 : t ?? `Please enter a number greater than or equal to ${e}`, k = (e, t) => (n) => n < e ? void 0 : t ?? `Please enter a number less than ${e}`, A = (e, t) => (n) => n <= e ? void 0 : t ?? `Please enter a number less than or equal to ${e}`, j = (e, t) => (n) => typeof n != "string" || n.length <= e ? void 0 : t ?? `Must not exceed ${e} characters`, M = (e) => e >= 0 && e <= 100 ? void 0 : "Please enter a number between 0 and 100", N = (e) => (t) => {
	if (t !== void 0) return h(t, e) ? void 0 : `Please enter a number with up to ${e} decimal places`;
}, P = (e) => typeof e == "string" && o.test(e) ? void 0 : "Please enter a number", F = (e) => typeof e == "string" && o.test(e) ? void 0 : "Please enter an integer", I = (e) => typeof e == "string" && a.test(e) ? void 0 : "Please enter a positive integer", L = (e) => {
	if (e !== void 0) return typeof e == "string" && s.test(e.trim()) ? void 0 : "Please enter a valid email address";
}, ne = (e) => {
	if (e !== void 0) return typeof e == "string" && c.test(e) ? void 0 : "Please enter a valid URL";
}, R = (e) => {
	if (e !== void 0) return typeof e == "string" && e.startsWith("https://docs.google.com") ? void 0 : "Please enter a valid Google Sheet URL";
}, z = (e) => typeof e == "string" && l.test(e) ? void 0 : "Please enter a number with 3 digits", B = (e) => typeof e == "string" && u.test(e) ? void 0 : "Please enter a number with 5 digits";
function V(e, t) {
	return (n) => typeof n == "string" && o.test(n) && n.length >= e && n.length <= t ? void 0 : `Please enter a number with between ${e} and ${t} digits`;
}
var H = (e) => typeof e == "string" && d.test(e) ? void 0 : "Please enter a number with 6 digits", U = (e) => typeof e == "string" && f.test(e) ? void 0 : "Please enter a number with 8 digits", W = (e) => typeof e == "string" && p.test(e) ? void 0 : "Please enter a number with 9 digits", G = (e) => typeof e == "string" && m.test(e) ? void 0 : "Please enter a valid Swift Code", K = (e, t) => (n) => Array.isArray(n) && n.length >= e ? void 0 : `Please enter at least ${e} ${t}`, q = (e) => (t) => {
	if (t !== void 0) return typeof t == "string" && !e.map((e) => e.toLowerCase()).includes(t.toLowerCase()) ? void 0 : "Must be unique";
}, J = (e) => {
	if (e !== void 0) try {
		JSON.parse(e);
	} catch {
		return "Please enter valid JSON";
	}
}, Y = (e) => {
	if (!(e instanceof Date)) return !1;
	try {
		if (e.toString() === "Invalid Date") return !1;
	} catch {
		return !1;
	}
	return !0;
}, X = (e) => Y(e) ? void 0 : "Date is invalid", Z = (e) => ({ dateString: t }) => {
	if (e[t]) return `${t} is a holiday and not selectable`;
}, re = ({ dateObject: e, dateString: t }) => {
	let n = e.getDay();
	if (n === 0 || n === 6) return `${t} is a weekend day and not selectable`;
}, ie = ({ permitEmpty: e }) => (t) => {
	if (t === void 0 || !Array.isArray(t) || t.length === 0) return "Please enter at least one email address";
	let n = t.filter((t) => !(e && !t));
	if (new Set(n).size !== n.length) return "Please remove any duplicate email addresses";
	if (!n.reduce((e, t) => typeof t == "string" && s.test(t) ? e + 1 : e, 0)) return "Please enter at least one email address";
	let r = n.filter((e) => typeof e == "string" && !s.test(e));
	if (r.length === 1) return `${r[0]} is not a valid email address`;
	if (r.length > 1) return `${r.join(", ")} are not valid email addresses`;
}, ae = (e) => {
	switch (e) {
		case "INTEGER": return F;
		case "POSITIVE_INTEGER": return g(I, O(0));
		case "NUMBER": return Q;
		case "POSITIVE_NUMBER": return $;
	}
}, oe = ({ validator: n, valueDescription: r, permitEmptyValue: i = !1, permitEmptyArray: a = !1 }) => (o) => {
	if (o === void 0 || !Array.isArray(o) || !a && o.length === 0) return `Please enter at least one ${t(r)}`;
	let s = o.filter((e) => !(i && !e));
	if (new Set(s).size !== s.length) return `Please remove any duplicate ${e(r)}`;
	let c = s.reduce((e, t) => n(t) === void 0 ? e + 1 : e, 0);
	if (!a && !c) return `Please enter at least one ${t(r)}`;
	let l = s.filter((e) => n(e) !== void 0);
	if (l.length === 1) return `${l[0]} is not a valid ${t(r)}`;
	if (l.length > 1) return `${l.join(", ")} are not valid ${e(r)}`;
}, Q = (e) => {
	if (typeof e != "number") {
		if (typeof e == "string") {
			let t = e.trim();
			if (!isNaN(Number(t)) && t !== "") return;
		}
		return "Please enter a number";
	}
}, $ = (e) => Q(e) === void 0 && Number(e) > 0 ? void 0 : "Please enter a positive number", se = (e) => (t) => t.map((t) => t(e)).filter(Boolean);
//#endregion
export { Y as A, _ as B, J as C, P as D, $ as E, j as F, H as G, b as H, W as I, z as J, v as K, q as L, k as M, A as N, Z as O, T as P, V as R, F as S, I as T, y as U, te as V, ee as W, h as X, X as Y, ae as Z, D as _, n as a, ie as b, g as c, x as d, w as f, oe as g, B as h, i, re as j, ne as k, S as l, U as m, s as n, c as o, N as p, G as q, r, K as s, se as t, E as u, O as v, Q as w, R as x, L as y, M as z };

//# sourceMappingURL=validation-C1j4XYsm.js.map